// extracted by mini-css-extract-plugin
module.exports = {"section":"sectionEight_section__2DpOr","itemRow11":"sectionEight_itemRow11__iGPjD","itemRow12":"sectionEight_itemRow12__fZCaR","itemRow2":"sectionEight_itemRow2__3G3td"};